/** True when Q19 was saved from PaymentInformation (card, insurance, or plan credits). */
export function isIntakePaymentQuestionComplete(q19: Record<string, unknown> | undefined): boolean {
  if (!q19 || typeof q19 !== 'object') return false;
  if (q19.payWithCredit === true) return true;
  const hasValue = (x: unknown): boolean =>
    x != null && x !== '' && !(typeof x === 'number' && (!Number.isFinite(x) || x === 0));
  return hasValue(q19.paymentId) || hasValue(q19.insuranceId) || hasValue(q19.secondaryInsuranceId);
}
